import ApiUtils from '@/utils/api/ApiUtils'
import Const from './Const'

// TODO: can i know what storeConst properties are available? (using intelisense)
// eslint-disable-next-line no-unused-vars
const StoreConst = Const.storeConst
const store = {
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async projectBacker_doBrowse ({ commit, state }, payload) {
      const val = {
        searchInfo: state.searchInfo,
        orderBy: state.orderBy,
        pagination: state.pagination
      }
      const res = await ApiUtils.postData({
        data: [{ api: 'C1301ProjectCrowdFundPledgeService.projectBacker_doBrowse', input: val }]
      })
      commit('SET_ROWS', res[0].output.data)
      commit('SET_PAGINATION', res[0].output.pagination)
    },
    // custom action
    async projectBacker_getShippingInfo ({ commit, state }, payload) {
      const res = await ApiUtils.postData({
        data: [
          {
            api: 'C1301ProjectCrowdFundPledgeService.projectBacker_getShippingInfo',
            input: payload
          }]
      })
      return res[0].output
    },
    async projectBacker_getStatistics ({ commit, state }, payload) {
      const res = await ApiUtils.postData({
        data: [
          {
            api: 'C1301ProjectCrowdFundPledgeService.projectBacker_getStatistics',
            input: payload
          }]
      })
      return res[0].output
    },
    async projectBacker_goToChatroom ({ commit, state }, payload) {
      return ApiUtils.postData({
        data: [{ api: 'C1301ProjectCrowdFundPledgeService.projectBacker_goToChatroom', input: payload }]
      }).then((res) => {
        return res[0].output
      })
    }
  }
}

export default Const.getStore(store)
